<template>
  <div class="networkclassroomIndex">
		<div class="contentTop">
			<banner></banner>
			
			<div class="contentMiddle">
				<headerview></headerview>
				
				<div class="con_all">		
					<div class="con_one">						
						
						<div style="margin-left: 0.06rem;">
							<tipsign :titleName="'网络课堂'"></tipsign>
						</div>
						
						<div class="blackcar">
							<div class="blackcar_a">
								<div class="blackcar_a_top">
									<div class="titlecar">
										<div style="margin-left: 0.4rem;margin-bottom: 0.08rem;">
											<span style="color: #E61F26;font-size: 0.30rem;font-weight: bold;">知识</span>
											<span style="font-size: 0.24rem;font-weight: bold;">汇编</span>
											<div style="color: #999999;font-size: 0.2rem;">
												Knowledge compilation
											</div>
										</div>
										
										<div style="height: 0.1rem;background:#E61F26;border-radius:0.2rem;"></div>
									</div>
									<span style="color: #E61F26;font-size: 0.14rem;margin-top: 0.55rem;cursor: pointer;" @click="moreSpecial(1)">更多> </span>
								</div>
								
								<div class="blackcar_a_con">
									<div class="projectcar" v-for="(item,index) in knowledgelist" :key="index" @click="todetailzs(item)">
										<div class="imgcon">
											<img :src="$fileAccessHttpUrl(item.thumbnail_dictText)" alt=""/>
										</div>
										<div class="textcon">
											<div class="textcon_a">{{item.compilationTitle}}</div>
											<div class="textcon_b">
												{{item.compilationContent?gethypertext(item.compilationContent):''}}
											</div>
											<div class="textcon_c">{{item.createTime}}</div>
										</div>
									</div>
								</div>
							</div>
							<div class="blackcar_b">
								<div class="blackcar_b_top">
									<div class="titlecar">
										<div style="margin-left: 0.4rem;margin-bottom: 0.08rem;">
											<span style="color: #E61F26;font-size: 0.30rem;font-weight: bold;">少年队</span>
											<span style="font-size: 0.24rem;font-weight: bold;">网络视频</span>
											<div style="color: #999999;font-size: 0.2rem;">
												Youth team online video
											</div>
										</div>
										
										<div style="height: 0.1rem;background:#E61F26;border-radius:0.2rem;"></div>
									</div>
									<span style="color: #E61F26;font-size: 0.14rem;margin-top: 0.55rem;cursor: pointer;" @click="moreSpecial(2)">更多> </span>
								</div>
								
								<div class="blackcar_b_con">
									<div class="projectcar" v-for="(item,index) in youthteamllist" :key="index">
										<img :src="$fileAccessHttpUrl(item.cover_dictText)" alt="" @click="toVideoOnline(item)"/>
									</div>
								</div>
								
							</div>
							<div class="blackcar_c">
								<div class="blackcar_c_top">
									<div class="titlecar">
										<div style="margin-left: 0.4rem;margin-bottom: 0.08rem;">
											<span style="color: #E61F26;font-size: 0.30rem;font-weight: bold;">文化</span>
											<span style="font-size: 0.24rem;font-weight: bold;">产品</span>
											<div style="color: #999999;font-size: 0.2rem;">
												Cultural products
											</div>
										</div>
										
										<div style="height: 0.1rem;background:#E61F26;border-radius:0.2rem;"></div>
									</div>
									<span style="color: #E61F26;font-size: 0.14rem;margin-top: 0.55rem;cursor: pointer;" @click="moreSpecial(3)">更多> </span>
								</div>
								
								<div class="blackcar_c_con">
									<div class="projectcar" v-for="(item,index) in culturallist" :key="index" @click="todetailwh(item)">
										<div class="imgCar">
											<img :src="$fileAccessHttpUrl(item.picture_dictText)" alt=""/>
										</div>
										<div class="textCar">
											{{item.title}}
										</div>
									</div>
								</div>
							</div>
						</div>
						
					</div>
				
				</div>
				
			</div>	
						
		<footview></footview>

  </div>
  
 </div> 
</template>

<script>
import headerview from "../../../components/headerview/headerview.vue";
import tipsign from "../../../components/tipsign/tipsign.vue";

export default {
  components: {
		headerview,
		tipsign,
  },
  
  data() {
		return {
			knowledgelist:[],
			youthteamllist:[],
			culturallist:[],
			
		};
  },
  
  mounted() {
		this.getKnowledge();
		this.getYouthTeam();
		this.getCultural();
		this.$onScrollT()
  },
  
  methods: {
	  //过滤富文本
	  gethypertext(str){
	  		  if(str == null){
	  		  		return "";
	  		  }
	  		  var str = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, "")
	  		              .replace(/&ldquo;/gi, "").replace(/\n/gi, "");
	  		  str = str.substring(0,30);
	  		  return str;
	  },
	  
	  //知识汇编
	  getKnowledge(){
			this.$get(`web/knowledgeCompilation/list?pageSize=4&pageNo=1`).then(res=>{
				  if(res.success){
						this.knowledgelist = res.result.records
				  }
			})
	  },
	  
	  //跳转到知识汇编详情
	  todetailzs(item){
	  		  this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:10} });
	  },
	  
	  //少年队网络视频
	  getYouthTeam(){
			this.$get(`web/teaching/list?pageSize=4&pageNo=1`).then(res=>{
				  if(res.success){
						this.youthteamllist = res.result.records
				  }
			})
	  },
	  
	  //跳转视频网络课程详情
	  toVideoOnline(item){
	  		   this.$router.push({ path: '/videoonlinecourse', query: {id:item.id}});
	  },
	  
	  //文化产品
	  getCultural(){
			this.$get(`web/culturalproduct/list?pageSize=6&pageNo=1`).then(res=>{
				  if(res.success){
						this.culturallist = res.result.records
				  }
			})
	  },
	  
	  //跳转到文化产品详情
	  todetailwh(item){
	  		this.$router.push({ path: '/pressrelease/detail', query: {id:item.id,type:12} });
	  },
	  
	  moreSpecial(sign){
		  if(sign == 1){
				this.$router.push({ path: '/pressrelease', query: {type:10} });
		  }else if(sign == 2){
			    this.$router.push({ path: '/pressrelease', query: {type:11} });
		  }else if(sign == 3){
			    this.$router.push({ path: '/pressrelease', query: {type:12} });
		  }
		  
	  },
	  
	  
  }
};
</script>

<style scoped lang="scss">
	.networkclassroomIndex{
		.contentTop{
			// background-image: linear-gradient(#FFFFFF, #E98257);
		}
		
		.contentMiddle{
			padding-top: 1.7rem;
			height: 18.2rem;
			// border: 1px solid #FFFFFF;
			// background: linear-gradient(0deg, #FFFFFF, #E98257);
			.con_all{
				height: 16rem;	
				margin: 0rem auto;
				// margin-left: 4rem;
				// margin-right: 4rem;
				width: 12.15rem;
				background: #FFFFFF;
				.con_one{
					margin-top: 0.1rem;	
					.blackcar{
						margin-top: 0.1rem;
						height: 12rem;
						// border: 1px solid red;
						margin-left: 0.6rem;
						margin-right: 0.6rem;
						.blackcar_a{
							.blackcar_a_top{
								height: 0.8rem;
								border-bottom: 0.01rem solid #ededed;
								display: flex;
								justify-content: space-between;							
							}
							.blackcar_a_con{
								margin-top: 0.4rem;
								height: 3.4rem;
								// border: 1px solid blue;
								display: flex;
								flex-wrap: wrap;
								// align-items: center;
								justify-content: space-between;
								box-sizing: border-box;
								width: 100%;
								.projectcar{
									cursor: pointer;
									width: 48%;
									height: 1.3rem;
									// border: 1px solid red;
									display: flex;
									.imgcon{
										flex: 1.2;
										img{
											height:100%;
											width: 100%;
										}
									}
									.textcon{
										margin: 0.05rem 0rem 0.05rem 0.15rem;
										flex: 2;
										font-size: 0.18rem;
										color: #999999;
										display: flex;
										flex-direction: column;
										justify-content: space-between;
										.textcon_a{
											color: #333333;
											font-size: 0.2rem;
											font-weight: bold;
										}
									}
								}
							}
						}
						.blackcar_b{
							margin-top: 0.1rem;
							.blackcar_b_top{
								height: 0.8rem;
								border-bottom: 0.01rem solid #ededed;
								display: flex;
								justify-content: space-between;
								
							}
							.blackcar_b_con{
								margin-top: 0.4rem;
								height: 3.4rem;
								// border: 1px solid blue;
								display: flex;
								flex-wrap: wrap;
								// align-items: center;
								justify-content: space-between;
								box-sizing: border-box;
								width: 100%;
								.projectcar{
									cursor: pointer;
									width: 49.5%;
									height: 1.6rem;
									// border: 1px solid red;
									img{
										width: 100%;
										height: 1.6rem;
									}
								}
							}
						}
						.blackcar_c{
							margin-top: 0.1rem;
							.blackcar_c_top{					
								height: 0.8rem;
								border-bottom: 0.01rem solid #ededed;
								display: flex;
								justify-content: space-between;							
							}
							.blackcar_c_con{
								margin-top: 0.4rem;
								height: 5rem;
								// border: 1px solid blue;
								display: flex;
								flex-wrap: wrap;
								// align-items: center;
								// justify-content: space-between;
								box-sizing: border-box;
								width: 100%;
								.projectcar{
									cursor: pointer;
									width: 29%;
									margin-left: 0.1rem;
									margin-right: 0.3rem;
									height: 2.5rem;
									// border: 1px solid red;
									.imgCar{
										width: 100%;
										text-align: center;
										img{
											height: 1.5rem;
											width: 100%;
										}										
									}
									.textCar{
										font-size: 0.18rem;
										color: #999999;
									}
								}
							}
						}
						
					}							
				}					
				
				
			}
			
		}	
		
		
	}
	
</style>
